import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

type ReturnDate =
  | "dd/MM/yyyy"
  | "dd/MM"
  | "dd/MM/yyyy HH:mm"
  | "dd/MM/yyyy HH:mm:ss"
  | "yyyy-MM-dd"
  | "yyyy-MM-dd HH:mm:ss"
  | "EEEE, dd 'de' MMMM 'de' yyyy";

const formatDateEndOfDay = (
  date: string | Date,
  formatReturn: ReturnDate = "dd/MM/yyyy"
) => {
  if (!date) return "";
  const dateToString = date.toString().slice(0, 10).concat("T23:59:59.000Z");

  return format(dateToString, formatReturn, { locale: ptBR });
};

const formatDate = (
  date: string | Date,
  formatReturn: ReturnDate = "dd/MM/yyyy"
) => {
  return format(date, formatReturn, { locale: ptBR });
};

export { formatDate, formatDateEndOfDay };
